import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Menu, MenuItem } from "@mui/material";
import Header from "./common/header";
import {
  PersonAdd,
  KeyboardArrowDown,
  Phone,
  PeopleOutline,
} from "@mui/icons-material";
import GuestDetails from "./GuestDetails";
import useApi from "../hooks/useApi";
import {
  guestCheckInApi,
  guestListApi,
  // guestBookingApi,
} from "../api/controller/accounts/guest";
import loadingGif from "../assets/loading.gif";
import { route } from "preact-router";

const PresetContainer = styled("div")`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

const CenteredContent = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const PresetTitle = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  text-align: left;
  @media (max-width: 425px) {
    padding-bottom: 40px;
  }
`;

const PresetSubtitle = styled("div")`
  display: flex;
  align-items: center;
  color: #f7f7f7;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
  font-family: Poppins;
  padding-bottom: 15px;
  gap: 20px;

  @media (max-width: 924px) {
    padding-left: 10px;
    font-size: 20px;
  }

  @media (max-width: 380px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const GuestListHeader = styled("div")`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 15px;

  @media (max-width: 380px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const TimelineButton = styled("button")`
  width: 146px;
  height: 35px;
  padding: 0 12px;
  border: 0;
  box-sizing: border-box;
  border-radius: 44px;
  box-shadow: -1px 1px 10px #f0c3f1;
  background-color: #1c1c1e;
  color: #ffffff;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: -1px 1px 15px #f0c3f1;
  }

  svg {
    font-size: 18px;
  }

  @media (max-width: 380px) {
    margin-left: 10px;
  }
`;

const CheckInQuestion = styled("div")`
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
  padding-bottom: 15px;
  margin-top: 20px;

  @media (max-width: 924px) {
    padding-left: 10px;
    font-size: 20px;
  }
`;

const CheckInGrid = styled("div")`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 0 10px;

  @media (min-width: 924px) {
    gap: 30px;
    padding: 0 20px;
  }

  @media (min-width: 1024px) {
    gap: 30px;
    padding: 0;
    margin-bottom: 0;
  }
`;

const CheckInCard = styled("div")`
  border: 1px solid rgb(51, 51, 51);
  background: #2a2a2a;
  border-radius: 16px;
  padding: 20px;
  width: 100%;
  min-height: 350px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  @media (max-width: 924px) {
    max-width: 100%;
    padding: 16px;
    min-height: 300px;
  }
`;

const CardSubtitle = styled("p")`
  color: #c4c4c4;
  font-size: 12px;
  margin: 0 0 16px 0;
  font-family: Poppins;
`;

const CardDate = styled("div")`
  color: #c4c4c4;
  font-size: 12px;
  margin-bottom: 20px;
  text-align: right;
  font-family: Poppins;
`;

const MainValue = styled("div")`
  color: #fff;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 8px;
  font-family: Poppins;

  @media (max-width: 924px) {
    font-size: 36px;
  }
`;

const ValueRange = styled("div")`
  color: #c4c4c4;
  font-size: 14px;
  margin-bottom: 20px;
  font-family: Poppins;
`;

const ChartContainer = styled("div")`
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 6px;
  height: 120px;
  width: 100%;
  padding: 0;
  margin-bottom: 30px;
`;

const Bar = styled("div")`
  background: ${(props) =>
    props.active ? "rgb(103, 65, 217)" : "rgba(103, 65, 217, 0.2)"};
  border-radius: 8px 8px 0 0;
  width: 80px;
  height: ${(props) => props.height}%;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;

  &:hover {
    background: rgb(103, 65, 217);
  }

  @media (max-width: 400px) {
    width: 60px;
  }
`;

const BarValue = styled("div")`
  position: absolute;
  top: -18px;
  font-size: 10px;
  color: #fff;
  font-weight: 600;
  font-family: Poppins;
`;

const BarLabel = styled("div")`
  position: absolute;
  bottom: -22px;
  font-size: 10px;
  color: #c4c4c4;
  font-family: Poppins;
  white-space: nowrap;
  text-align: center;

  @media (max-width: 400px) {
    white-space: normal;
    width: 40px;
    bottom: -30px;
  }
`;

const GuestListContainer = styled("div")`
  border: 1px solid rgb(51, 51, 51);
  margin-top: 30px;
  background: #2a2a2a;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
`;

const GuestTable = styled("div")`
  display: grid;
  grid-template-columns: 120px 1fr 1fr 200px;
  gap: 20px;
  font-family: Poppins;

  @media (max-width: 924px) {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

const GuestHeader = styled("div")`
  display: contents;

  @media (max-width: 924px) {
    display: none;
  }
`;

const GuestHeaderCell = styled("div")`
  padding: 12px 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 2px solid rgba(103, 65, 217, 0.3);
  margin-bottom: 10px;
`;

const GuestRow = styled("div")`
  display: contents;

  &:nth-child(even) > div {
  }

  @media (max-width: 924px) {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    gap: 12px;
  }
`;

const GuestCell = styled("div")`
  padding: 12px 8px;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 924px) {
    display: none;
  }
`;

const MobileGuestNumber = styled("div")`
  @media (max-width: 924px) {
    width: 30px;
    height: 30px;

    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }

  @media (min-width: 925px) {
    display: none;
  }
`;

const MobileGuestInfo = styled("div")`
  @media (max-width: 924px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2px;
  }

  @media (min-width: 925px) {
    display: none;
  }
`;

const MobileGuestTime = styled("div")`
  @media (max-width: 924px) {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }
`;

const MobileGuestName = styled("div")`
  @media (max-width: 924px) {
    color: #c4c4c4;
    font-size: 12px;
    font-weight: 400;
  }
`;

const MobileGuestCovers = styled("div")`
  @media (max-width: 924px) {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: 925px) {
    display: none;
  }
`;

const EnterGuestButton = styled("div")`
  background: rgb(103, 65, 217);
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 15px rgba(103, 65, 217, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  margin-bottom: 20px;

  @media (min-width: 425px) {
    width: 100%;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(103, 65, 217, 0.4);
    background: rgba(103, 65, 217, 0.8);
  }

  &:active {
    transform: translateY(-2px);
  }
`;

const EnterGuestIcon = styled("div")`
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EnterGuestTitle = styled("h3")`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

const ClickMoreContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
`;

const ClickMoreButton = styled("button")`
  min-width: 200px;
  text-transform: none;
  line-height: 60px;
  padding: 0px 8px;
  border: 0;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: -1px 1px 10px #f0c3f1;
  background-color: #6741d9;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  outline: none;
  font-family: Poppins;
  margin-top: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 924px) {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }

  &:hover {
    background-color: #5a37c7;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(103, 65, 217, 0.4);
  }
`;

const CheckInPreset = () => {
  const [showGuestDetails, setShowGuestDetails] = useState(false);
  const [selectedMobile, setSelectedMobile] = useState("");

  // Timeline filter state
  const [selectedTimeline, setSelectedTimeline] = useState("today");
  const [timelineAnchorEl, setTimelineAnchorEl] = useState(null);
  const timelineMenuOpen = Boolean(timelineAnchorEl);

  // Separate timeline state for check-in card
  const [checkInTimeline, setCheckInTimeline] = useState("today");
  const [checkInTimelineAnchorEl, setCheckInTimelineAnchorEl] = useState(null);
  const checkInTimelineMenuOpen = Boolean(checkInTimelineAnchorEl);

  const timelineOptions = [
    { value: "today", label: "Today" },
    { value: "this_week", label: "This Week" },
    { value: "this_month", label: "This Month" },
    { value: "last_30_days", label: "Last 30 Days" },
  ];

  const getTimelineLabel = (value) => {
    const option = timelineOptions.find((opt) => opt.value === value);
    return option ? option.label : "Today";
  };

  const [checkInData, setCheckInData] = useState([
    {
      id: 1,
      icon: "👥",
      title: "Total Check-in today",
      date: "Today",
      subtitle: "Hourly distribution",
      mainValue: "0",
      valueRange: "Peak time",
      chartData: [
        { label: "Upto 12pm", value: "0", height: 0 },
        { label: "12pm to 3pm", value: "0", height: 0 },
        { label: "3pm to 6pm", value: "0", height: 0 },
        { label: "6pm to 9pm", value: "0", height: 0 },
        { label: "After 9pm", value: "0", height: 0 },
      ],
    },
  ]);

  const checkInRequest = useApi();
  const guestListRequest = useApi();
  // const bookingRequest = useApi();

  // Guest list pagination state (following PromotePreset pattern)
  const [guestListData, setGuestListData] = useState([]);
  const [guestListOffset, setGuestListOffset] = useState(0);
  const [guestListEndReached, setGuestListEndReached] = useState(false);
  const [lastDataLength, setLastDataLength] = useState(0);
  const [lastDataIds, setLastDataIds] = useState([]);
  const limit = 20;

  // Booking data state
  // const [upcomingBookings, setUpcomingBookings] = useState([]);
  // const [bookingOffset, setBookingOffset] = useState(0);
  // const [bookingEndReached, setBookingEndReached] = useState(false);
  // const bookingLimit = 5;

  // Function to get guest list data with pagination
  const getGuestListData = (offset) => {
    console.log(
      "🔍 getGuestListData called with offset:",
      offset,
      "limit:",
      limit,
      "filter_date:",
      selectedTimeline
    );
    return guestListApi(
      guestListRequest.request,
      limit,
      offset,
      selectedTimeline
    );
  };

  // Function to get booking data with pagination
  // const getBookingData = (offset) => {
  //   return guestBookingApi(bookingRequest.request, bookingLimit, offset);
  // };

  const handleEnterGuestDetails = () => {
    setShowGuestDetails(true);
  };

  const handleBackFromGuestDetails = () => {
    setShowGuestDetails(false);
  };

  const fetchCheckInData = () => {
    return guestCheckInApi(checkInRequest.request, selectedTimeline);
  };

  // Handle timeline menu for "Today's Check-in" section (both stats and guest list)
  const handleTimelineClick = (event) => {
    setTimelineAnchorEl(event.currentTarget);
  };

  const handleTimelineClose = () => {
    setTimelineAnchorEl(null);
  };

  const handleTimelineSelect = (timeline) => {
    setSelectedTimeline(timeline);
    setCheckInTimeline(timeline); // Also update check-in card timeline
    setTimelineAnchorEl(null);
    // Reset guest list data and reload both APIs
    setGuestListData([]);
    setGuestListOffset(0);
    setGuestListEndReached(false);
    guestCheckInApi(checkInRequest.request, timeline);
    guestListApi(guestListRequest.request, limit, 0, timeline);
  };

  // Handle timeline menu for check-in card only (inside the card)
  const handleCheckInTimelineClick = (event) => {
    setCheckInTimelineAnchorEl(event.currentTarget);
  };

  const handleCheckInTimelineClose = () => {
    setCheckInTimelineAnchorEl(null);
  };

  const handleCheckInTimelineSelect = (timeline) => {
    setCheckInTimeline(timeline);
    setCheckInTimelineAnchorEl(null);
    // Only reload check-in stats, not guest list
    guestCheckInApi(checkInRequest.request, timeline);
  };

  useEffect(() => {
    fetchCheckInData();
    getGuestListData(0); // Load initial guest list data
    // getBookingData(0); // Load initial booking data
  }, []);

  useEffect(() => {
    if (checkInRequest.data && checkInRequest.data.data) {
      const { total_guest_count, distribution_data } = checkInRequest.data.data;

      // Find the maximum guest count for scaling the chart
      const maxCount = Math.max(
        ...distribution_data.map((item) => item.guest_count)
      );

      // Transform API data to match existing structure
      const transformedChartData = distribution_data.map((item) => ({
        label: item.time_slot,
        value: item.guest_count.toString(),
        height: maxCount > 0 ? (item.guest_count / maxCount) * 100 : 0,
        active: item.guest_count === maxCount && maxCount > 0,
      }));

      setCheckInData([
        {
          id: 1,
          icon: "👥",
          title: "Total Check-in today",
          date: "Today",
          subtitle: "Hourly distribution",
          mainValue: total_guest_count.toString(),
          valueRange: "Peak time",
          chartData: transformedChartData,
        },
      ]);
    }
  }, [checkInRequest.data]);

  // Handle guest list data response (following PromotePreset pattern)
  useEffect(() => {
    if (
      guestListRequest.data &&
      guestListRequest.data.data &&
      Array.isArray(guestListRequest.data.data)
    ) {
      const newDataLength = guestListRequest.data.data.length;
      console.log("🔍 Processing guest list data:", {
        newData: guestListRequest.data.data,
        newDataLength,
        lastDataLength,
        offset: guestListOffset,
      });

      // Create unique identifiers for the new data
      const newDataIds = guestListRequest.data.data.map(
        (item) => `${item.user}-${item.checkin_time}-${item.total_guests}`
      );

      // Check if we got the same data as last time (comparing actual content)
      if (guestListOffset > 0 && newDataLength > 0) {
        const hasSameData = newDataIds.every((id) => lastDataIds.includes(id));
        if (hasSameData && newDataIds.length === lastDataIds.length) {
          console.log(
            "🔍 Same data detected, setting end reached to prevent duplicates"
          );
          setGuestListEndReached(true);
          return;
        }
      }

      // If there is data, update the state variables
      setGuestListData((prevData) =>
        guestListOffset === 0 // If we are reloading the state, reset list
          ? [...guestListRequest.data.data]
          : [...prevData, ...guestListRequest.data.data]
      );

      // Update last data length and IDs for comparison
      setLastDataLength(newDataLength);
      setLastDataIds(newDataIds);

      // Check if we've reached the end
      if (newDataLength === 0 || newDataLength < limit) {
        console.log("🔍 No more data, setting guestListEndReached to true");
        setGuestListEndReached(true);
      }
    }
  }, [guestListRequest.data, guestListOffset]);

  // Handle booking API response
  // useEffect(() => {
  //   if (
  //     bookingRequest.data &&
  //     bookingRequest.data.data &&
  //     Array.isArray(bookingRequest.data.data)
  //   ) {
  //     console.log(
  //       "🔍 Processing booking data:",
  //       bookingRequest.data.data
  //     );

  //     // If there is data, update the state variables
  //     // setUpcomingBookings((prevData) =>
  //     //   bookingOffset === 0 // If we are reloading the state, reset list
  //     //     ? [...bookingRequest.data.data]
  //     //     : [...prevData, ...bookingRequest.data.data]
  //     // );

  //     // Check if we've reached the end
  //     if (bookingRequest.data.data.length === 0) {
  //       console.log("🔍 No more booking data, setting bookingEndReached to true");
  //       setBookingEndReached(true);
  //     }
  //   }
  // }, [bookingRequest.data]);

  // Load more data function
  const loadMoreGuestListData = () => {
    console.log("🔍 loadMoreGuestListData called:", {
      guestListEndReached,
      loading: guestListRequest.loading,
      currentOffset: guestListOffset,
    });

    if (!guestListEndReached && !guestListRequest.loading) {
      const newOffset = guestListOffset + 1; // Increment by 1, not by limit
      console.log("🔍 Loading more data with offset:", newOffset);
      setGuestListOffset(newOffset);
      getGuestListData(newOffset);
    } else {
      console.log(
        "🔍 Not loading more data - either end reached or already loading"
      );
    }
  };

  // Load more booking data function
  // const loadMoreBookingData = () => {
  //   console.log("🔍 loadMoreBookingData called:", {
  //     bookingEndReached,
  //     loading: bookingRequest.loading,
  //     currentOffset: bookingOffset,
  //   });

  //   if (!bookingEndReached && !bookingRequest.loading) {
  //     const newOffset = bookingOffset + 1;
  //     console.log("🔍 Loading more booking data with offset:", newOffset);
  //     setBookingOffset(newOffset);
  //     getBookingData(newOffset);
  //   } else {
  //     console.log(
  //       "🔍 Not loading more booking data - either end reached or already loading"
  //     );
  //   }
  // };

  // Scroll event handler for guest list infinite scroll
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    console.log("🔍 Scroll event:", { scrollTop, scrollHeight, clientHeight });

    // Check if user scrolled to bottom (with 50px threshold)
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      console.log("🔍 User scrolled to bottom, checking if should load more");
      // Only trigger if we haven't reached the end and not already loading
      if (!guestListEndReached && !guestListRequest.loading) {
        console.log("🔍 Triggering load more");
        loadMoreGuestListData();
      } else {
        console.log("🔍 Not loading - end reached or already loading:", {
          guestListEndReached,
          loading: guestListRequest.loading,
        });
      }
    }
  };

  // Scroll event handler for booking list infinite scroll
  // const handleBookingScroll = (e) => {
  //   const { scrollTop, scrollHeight, clientHeight } = e.target;
  //   console.log("🔍 Booking scroll event:", { scrollTop, scrollHeight, clientHeight });

  //   // Check if user scrolled to bottom (with 50px threshold)
  //   if (scrollHeight - scrollTop <= clientHeight + 50) {
  //     console.log("🔍 User scrolled to bottom of bookings, checking if should load more");
  //     if (!bookingEndReached && !bookingRequest.loading) {
  //       console.log("🔍 Triggering load more bookings");
  //       loadMoreBookingData();
  //     } else {
  //       console.log("🔍 Not loading - end reached or already loading:", {
  //         bookingEndReached,
  //         loading: bookingRequest.loading,
  //       });
  //     }
  //   }
  // };

  if (showGuestDetails) {
    return (
      <GuestDetails
        onBack={handleBackFromGuestDetails}
        selectedMobileNumber={selectedMobile}
      />
    );
  }

  if (guestListRequest.loading || checkInRequest.loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            fontFamily: "Poppins",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          Loading...
        </div>
      </div>
    );
  }

  return (
    <PresetContainer>
      <Header />

      <CenteredContent>
        <PresetTitle>Check-in</PresetTitle>

        <CheckInQuestion>New Guest Check-in</CheckInQuestion>

        <EnterGuestButton onClick={handleEnterGuestDetails}>
          <EnterGuestIcon>
            <PersonAdd />
          </EnterGuestIcon>
          <EnterGuestTitle>Enter Guest Details</EnterGuestTitle>
        </EnterGuestButton>
        {/* 
        <PresetSubtitle>Upcoming Bookings</PresetSubtitle>
        <GuestListContainer style={{ marginTop: "0px" }}>
          <GuestTable
            onScroll={handleBookingScroll}
            style={{ overflowY: "auto", padding: "30px", maxHeight: "300px" }}
          >
            <GuestHeader>
              <GuestHeaderCell>Sl. No.</GuestHeaderCell>
              <GuestHeaderCell>Booking Time</GuestHeaderCell>
              <GuestHeaderCell>Guest Name</GuestHeaderCell>
              <GuestHeaderCell>Total Guests</GuestHeaderCell>
            </GuestHeader>
            {upcomingBookings.map((booking, index) => (
              <GuestRow key={`${booking.id}-${index}`}>
       
                <GuestCell>{index + 1}</GuestCell>
                <GuestCell>{booking.booking_time}</GuestCell>
                <GuestCell>
                  <div>
                    <div style={{ fontWeight: "500" }}>
                      {booking.guest_name}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#c4c4c4",
                        marginTop: "4px",
                      }}
                    >
                      {booking.mobile}
                    </div>
                  </div>
                </GuestCell>
                <GuestCell>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <span>
                      {booking.total_guests}{" "}
                      {booking.total_guests === 1 ? "Guest" : "Guests"}
                    </span>
                    <PeopleOutline
                      style={{
                        color: "#6741d9",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedMobile(booking.mobile);
                        setShowGuestDetails(true);
                      }}
                    />
                  </div>
                </GuestCell>

              
                <MobileGuestNumber>{index + 1}</MobileGuestNumber>
                <MobileGuestInfo>
                  <MobileGuestTime>{booking.booking_time}</MobileGuestTime>
                  <MobileGuestName>
                    <div style={{ fontWeight: "500" }}>
                      {booking.guest_name}
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#c4c4c4",
                        marginTop: "2px",
                      }}
                    >
                      {booking.mobile}
                    </div>
                  </MobileGuestName>
                </MobileGuestInfo>
                <MobileGuestCovers>
                  <div>
                    {booking.total_guests}{" "}
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#c4c4c4",
                        fontWeight: "400",
                      }}
                    >
                      {booking.total_guests === 1 ? "Guest" : "Guests"}
                    </span>
                  </div>
                  <PeopleOutline
                    style={{
                      color: "#6741d9",
                      fontSize: "18px",
                      cursor: "pointer",
                      marginTop: "4px",
                    }}
                    onClick={() => {
                      setSelectedMobile(booking.mobile);
                      setShowGuestDetails(true);
                    }}
                  />
                </MobileGuestCovers>
              </GuestRow>
            ))}
          </GuestTable> */}

        {/* Loading indicator for pagination */}
        {/* {bookingRequest.loading && upcomingBookings.length > 0 && (
            <div
              style={{
                textAlign: "center",
              }}
            >
              <img
                src={loadingGif}
                alt="Loading..."
                style={{ width: "36px", height: "10px" }}
              />
            </div>
          )} */}

        {/* Empty state */}
        {/* {upcomingBookings.length === 0 && !bookingRequest.loading && (
            <div
              style={{
                textAlign: "center",
                color: "#c4c4c4",
                padding: "40px 20px",
                fontFamily: "Poppins",
              }}
            >
              No Upcoming Bookings
            </div>
          )} */}
        {/* </GuestListContainer> */}
        <PresetSubtitle>
          Check-in{" "}
          <TimelineButton onClick={handleTimelineClick}>
            {getTimelineLabel(selectedTimeline)}
            <KeyboardArrowDown />
          </TimelineButton>
          <Menu
            anchorEl={timelineAnchorEl}
            open={timelineMenuOpen}
            onClose={handleTimelineClose}
            PaperProps={{
              style: {
                background: "#2a2a2a",
                color: "#fff",
                border: "1px solid #444",
              },
            }}
          >
            {timelineOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => handleTimelineSelect(option.value)}
                style={{
                  color: "#fff",
                  fontWeight: selectedTimeline === option.value ? "500" : "400",
                  background:
                    selectedTimeline === option.value
                      ? "#6741d9"
                      : "transparent",
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </PresetSubtitle>

        <CheckInGrid>
          {checkInData.map((item) => (
            <CheckInCard key={item.id}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "8px",
                }}
              >
                <MainValue
                  style={{
                    fontSize: "52px",
                    fontWeight: "700",
                    margin: "10px 0 5px 0",
                    textAlign: "left",
                    color: "#fff",
                  }}
                >
                  {item.mainValue}
                </MainValue>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#c4c4c4",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                  >
                    {getTimelineLabel(checkInTimeline)}
                  </div>
                  <Menu
                    anchorEl={checkInTimelineAnchorEl}
                    open={checkInTimelineMenuOpen}
                    onClose={handleCheckInTimelineClose}
                    PaperProps={{
                      style: {
                        background: "#2a2a2a",
                        color: "#fff",
                        border: "1px solid #444",
                      },
                    }}
                  >
                    {timelineOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        onClick={() =>
                          handleCheckInTimelineSelect(option.value)
                        }
                        style={{
                          color: "#fff",
                          fontWeight:
                            checkInTimeline === option.value ? "500" : "400",
                          background:
                            checkInTimeline === option.value
                              ? "#6741d9"
                              : "transparent",
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </div>
              {/* Large Number text - left aligned */}

              {/* Hourly distribution - left aligned */}
              <CardSubtitle
                style={{
                  fontSize: "12px",
                  color: "#c4c4c4",
                  margin: "0 0 15px 0",
                  textAlign: "left",
                }}
              >
                {item.subtitle}
              </CardSubtitle>

              {/* Chart container with proper height */}
              <div
                style={{
                  height: "250px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                  overflow: "hidden",
                }}
              >
                <ChartContainer>
                  {item.chartData.map((bar, barIndex) => (
                    <Bar key={barIndex} height={bar.height} active={bar.active}>
                      {bar.value !== "0" && <BarValue>{bar.value}</BarValue>}
                      <BarLabel>{bar.label}</BarLabel>
                    </Bar>
                  ))}
                </ChartContainer>
              </div>
            </CheckInCard>
          ))}
        </CheckInGrid>

        {/* <ClickMoreContainer>
          <ClickMoreButton>Check Analytics</ClickMoreButton>
        </ClickMoreContainer> */}
        {/* 
        <GuestListHeader>
          <PresetSubtitle>Guest List</PresetSubtitle>
        </GuestListHeader> */}

        <GuestListContainer>
          <GuestTable
            onScroll={handleScroll}
            style={{ overflowY: "auto", padding: "30px", maxHeight: "300px" }}
          >
            <GuestHeader>
              <GuestHeaderCell>Sl. No.</GuestHeaderCell>
              <GuestHeaderCell>Check-in Time</GuestHeaderCell>
              <GuestHeaderCell>Guest Name</GuestHeaderCell>
              <GuestHeaderCell>Total Guests</GuestHeaderCell>
            </GuestHeader>
            {guestListData.map((guest, index) => (
              <GuestRow key={`${guest.user}-${index}`}>
                {/* Desktop Layout */}
                <GuestCell>{index + 1}</GuestCell>
                <GuestCell>{guest.checkin_time}</GuestCell>
                <GuestCell>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>{guest.user}</span>
                    <span>{guest.mobile}</span>
                </div>
                </GuestCell>
                <GuestCell>
                  {guest.total_guests}{" "}
                  {guest.total_guests === 1 ? "Guest" : "Guests"}
                </GuestCell>

                {/* Mobile Layout */}
                <MobileGuestNumber>{index + 1}</MobileGuestNumber>
                <MobileGuestInfo>
                  <MobileGuestTime>{guest.checkin_time}</MobileGuestTime>
                  <MobileGuestName>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>{guest.user}</span>
                    <span>{guest.mobile}</span>
                  </div>
                  </MobileGuestName>
                </MobileGuestInfo>
                <MobileGuestCovers>
                  {guest.total_guests}{" "}
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#c4c4c4",
                      fontWeight: "400",
                    }}
                  >
                    {" "}
                    {guest.total_guests === 1 ? "Guest" : "Guests"}
                  </span>{" "}
                </MobileGuestCovers>
              </GuestRow>
            ))}
          </GuestTable>

          {/* Loading indicator for pagination */}
          {guestListRequest.loading && guestListData.length > 0 && (
            <div
              style={{
                textAlign: "center",
                padding: "10px",
              }}
            >
              <img
                src={loadingGif}
                alt="Loading..."
                style={{ width: "36px", height: "10px" }}
              />
            </div>
          )}

          {/* No more data message */}
          {guestListEndReached && guestListData.length > 0 && <div></div>}

          {/* Empty state */}
          {guestListData.length === 0 && !guestListRequest.loading && (
            <div
              style={{
                textAlign: "center",
                color: "#c4c4c4",
                padding: "40px 20px",
                fontFamily: "Poppins",
              }}
            >
              No Check-in Data
            </div>
          )}
        </GuestListContainer>
      </CenteredContent>
    </PresetContainer>
  );
};

export default CheckInPreset;
